import $ from "jquery";

class Header {
    constructor() {
        this.body = document.querySelector('body');
        this.body.classList.toggle('scrolled', $(window).scrollTop() > 0);

        $(window).on('scroll', () => {
            this.body.classList.toggle('scrolled', $(window).scrollTop() > 0);
        });
    }
}

export default Header;